import {
  leadsBulkAssigneePartialUpdateMutation,
  leadsListQueryKey,
  leadsPipelineListQueryKey,
  PaginatedReturnUserListReadable,
  PatchedBulkAsigneeLead,
  ReturnUserReadable,
  UsersListData,
  usersListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { FieldsProps, Properties } from '@crm/types'
import { userTransformResults } from '@crm/utils'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, Form, Modal } from 'antd'

import type { ModalProps } from 'antd'

const formName = 'assign-to'

type Props = {
  leads?: number[]
  dataFields?: FieldsProps
  onClose: () => void
} & ModalProps

export const AssignTo = ({ leads, onClose, ...props }: Props) => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const { notification } = App.useApp()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { mutate, isPending } = useMutation({
    ...leadsBulkAssigneePartialUpdateMutation(),
    onError: (e) => showApiErrors(e, form),
    onSuccess: (e: Properties) => {
      invalidateQueries([leadsListQueryKey(), leadsPipelineListQueryKey()])

      onClose()
      notification.success({
        message: t('success.success'),
        description: e.message
      })
    }
  })

  const onSubmit = (values: PatchedBulkAsigneeLead) => {
    mutate({
      body: {
        ...values,
        leads
      }
    })
  }

  return (
    <Modal
      title={t('contacts.re_assign_responsible')}
      cancelText={t('buttons.cancel')}
      onCancel={onClose}
      okText={t('buttons.save')}
      okButtonProps={{ htmlType: 'submit', form: formName }}
      loading={isPending}
      {...props}
    >
      <Form form={form} name={formName} onFinish={onSubmit} layout="vertical">
        <Form.Item name="assignee_to" label={t('contacts.responsible')}>
          <InfiniteSelect<
            UsersListData,
            PaginatedReturnUserListReadable,
            ReturnUserReadable
          >
            popupMatchSelectWidth
            placeholder={t('billing.choose_contractor')}
            getQueryFunction={usersListInfiniteOptions}
            getOptions={({ options }) => userTransformResults(options)}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
